import "./dmsLandingPage.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import PopUpModal from "../../src/Home/Modal/PopUpModal";
import { useLocation } from "react-router-dom";

import Footer from "../Home/Components/Footer";
import Header from "../header/Header";
import DmsHero from "./sections/hero";
import { useEffect } from "react";
import DmsAbout from "./sections/about";
import TrustedDms from "./sections/trustedDms";
import WorkflowDms from "./sections/workflowDms";
import BusinessOutcomesDms from "./sections/businessOutcomeDms";
import ProductExperienceDms from "./sections/productExperienceDms";
import FaqDms from "./sections/faqDms";
import IndustriesDms from "./sections/industriesDms";
import WhyChooseDms from "./sections/whyChooseDms";
import DmsComparison from "./sections/dmsComparison";
import DmsTrustedBrands from "./sections/dmsTrustedBrands";

const DmsLandingPage = () => {
    useEffect(() => {
        AOS.init({
            duration: 900,
            easing: "ease-out-cubic",
            once: true,
            offset: 80,
            delay: 0,
        });

        const timer = setTimeout(() => {
            AOS.refresh();
        }, 300);

        return () => clearTimeout(timer);
    }, []);
    const Location = useLocation();

    const isDmsPage = Location.pathname === "/dms";

    return (
        <>
            <Helmet>
                <title>
                    Distribution Management System | Sales & Distribution Software
                </title>
                <meta
                    name="description"
                    content="Manage distributors, retailers, sales orders, inventory, field operations, visits and sales teams with TechCognics Distribution Management System."
                />
                <meta
                    name="keywords"
                    content="DMS software, distribution management system, distributor management software, sales distribution software, inventory management system, retailer management software, field sales management"
                />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Distribution Management System | TechCognics"
                />
                <meta
                    property="og:description"
                    content="Streamline distributors, sales, inventory, orders, retailers and field operations with TechCognics DMS."
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:url"
                    content="https://www.techcognics.com/dms"
                />
                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />
                <meta
                    name="twitter:title"
                    content="Distribution Management System | TechCognics"
                />
                <meta
                    name="twitter:description"
                    content="Manage distribution, sales, inventory, orders and field operations with TechCognics DMS."
                />
            </Helmet>
            <PopUpModal />
            {/* {isDmsPage ? <DmsLandingHeader /> : <Header />} */}
            <Header/>
            <main id="main-content" role="main">
                <DmsHero/>
                <DmsAbout/>
                <TrustedDms/>
                <ProductExperienceDms />
                <DmsTrustedBrands/>
                <IndustriesDms/>
                <BusinessOutcomesDms/>
                <DmsComparison/>
                <WhyChooseDms/>
                <WorkflowDms/>
                <FaqDms/>   
            </main>
            {/* {isDmsPage ? <DmsLandingFooter /> : <Footer />} */}
            <Footer/>
        </>
    );
};

export default DmsLandingPage;